import { config } from 'api';
import { clientCookies } from 'utils/cookies';

import errorHandler from 'lib/utils/errorHandler';
import { addProducts } from 'apps/products/actions/products';
import { extractAndDeleteProductsFromSections } from 'apps/products/utils/extractAndDeleteProducts';
import {
  SUBSCRIPTIONS_MINIMAL_PLACED_ORDER_COUNT,
  SUBSCRIPTIONS_REGULAR_PLACED_ORDER_COUNT,
  SUBSCRIPTIONS_COOKIE_EXPIRATION_MONTHS,
} from 'apps/subscriptions/config';
import {
  reportRecommendationsPopupShown,
  reportRecommendationsDontShowAgainClicked,
} from '../utils/RecommendationsAnalytics';

export const SUBSCRIPTIONS_PCOP_RECOMMENDATIONS = 'SUBSCRIPTIONS_PCOP_RECOMMENDATIONS';
export const RECOMMENDATIONS_SHOW_MODAL = 'RECOMMENDATIONS_SHOW_MODAL';
export const RECOMMENDATIONS_HIDE_MODAL = 'RECOMMENDATIONS_HIDE_MODAL';

// Intentionally left uglified, because it's used in cookies
const SUBSCRIPTIONS_SHOW_PCOP_RECOMMENDATIONS = 'S_POCP_REC';
const SHOW_MODAL_TIMEOUT = 1500;

const cookieExpirationDate = () => {
  const cookieDate = new Date();
  cookieDate.setMonth(cookieDate.getMonth() + SUBSCRIPTIONS_COOKIE_EXPIRATION_MONTHS);
  return cookieDate;
};

const checkPlacedOrderCountRules = (POC) => (POC === SUBSCRIPTIONS_MINIMAL_PLACED_ORDER_COUNT)
  || (POC > SUBSCRIPTIONS_MINIMAL_PLACED_ORDER_COUNT && POC % SUBSCRIPTIONS_REGULAR_PLACED_ORDER_COUNT === 0);

const checkRecommendationsCookie = () => {
  const fromCookie = clientCookies && clientCookies.get(SUBSCRIPTIONS_SHOW_PCOP_RECOMMENDATIONS);
  return (fromCookie || 'true') === 'true';
};

export const shouldShowRecommendations = (userEligibility) => checkRecommendationsCookie()
  && checkPlacedOrderCountRules(userEligibility.poc)
  && userEligibility.hasRequiredBetafeatures
  && userEligibility.hasRecommendations;

export function toggleRecommendations(showRecommendations) {
  if (!showRecommendations) {
    reportRecommendationsDontShowAgainClicked();
  }
  return clientCookies && clientCookies.set(
    SUBSCRIPTIONS_SHOW_PCOP_RECOMMENDATIONS, showRecommendations, {
      expires: cookieExpirationDate(),
      httpOnly: false,
      secure: true,
    }
  );
}

const setRecommendedFops = (recommendations) => ({
  type: SUBSCRIPTIONS_PCOP_RECOMMENDATIONS,
  recommendations,
});

export function getRecommendedFops() {
  return (dispatch, getState, { network }) =>
    network.get(`${config.apiBasePath}/subscriptions/recommendations`)
      .then(response => {
        const recommendations = response.sections || [];
        const products = extractAndDeleteProductsFromSections(recommendations);
        dispatch(addProducts(products));
        dispatch(setRecommendedFops(recommendations));
      })
      .catch(errorHandler);
}

export function showRecommendationsModal(numberOfSubs, timeout = SHOW_MODAL_TIMEOUT) {
  return (dispatch) => {
    setTimeout(() => {
      reportRecommendationsPopupShown(numberOfSubs);
      dispatch({
        type: RECOMMENDATIONS_SHOW_MODAL,
      });
    }, timeout);
  };
}

export function hideRecommendationsModal() {
  return {
    type: RECOMMENDATIONS_HIDE_MODAL,
  };
}
